.backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  z-index: 90;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.overlay {
  position: fixed;
  inset: 0;
  z-index: 91;
  overflow-y: auto;
  /* ProductSuite manages its own background — just scroll-contain it */
}

/* Close button — top-right corner, above the ProductSuite content */
.closeBtn {
  position: fixed;
  top: 20px;
  right: 24px;
  z-index: 92;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(0, 0, 0, 0.6);
  color: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s;
}

.closeBtn:hover {
  color: #fff;
  border-color: rgba(255, 255, 255, 0.5);
  background: rgba(0, 0, 0, 0.8);
}
